var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col } from "react-bootstrap";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import { useSelector } from "react-redux";
import di from "../di/serviceLocator";
import Loader from "../../../../../shared-library/components/Loader";
var PartnerProfile = function (props) {
    // const [selectedPartnerAcount, setSelectedPartnerAccount] =
    //   useState<IClientSearchEntity>();
    // const selectedAcount = useSelector(
    //   (state: RootState) => state.Clients.ClientSearch.reducersData.selected
    // );
    var _a = __read(React.useState(), 2), profileDetails = _a[0], setProfileDetails = _a[1];
    var _b = __read(React.useState(), 2), loader = _b[0], setLoader = _b[1];
    var profileDetailsRedux = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.Partners.partnerProfDemMetNomSeg) === null || _a === void 0 ? void 0 : _a.reducersData) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.profile; });
    var _c = useSelector(function (state) { return state.Partners.partnerProfDemMetNomSeg.commonData; }), overviewLoader = _c.loader, errorData = _c.errorData;
    var selectedPartner = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.selectedPartner;
    });
    var getProfileOverviewDetails = function () {
        setLoader(true);
        di.partnerOverview
            .getPartnerProfDemMetNomSegDetails({
            AcCode: selectedPartner.accountCode,
            flg: selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.flag,
            page: 1,
            pageSize: 100,
        })
            .then(function (resp) {
            if (resp && (resp === null || resp === void 0 ? void 0 : resp.profile)) {
                setProfileDetails(resp.profile);
            }
            else {
                setProfileDetails({});
            }
            setLoader(false);
        })
            .catch(function (error) {
            setProfileDetails({});
            setLoader(false);
        });
    };
    React.useEffect(function () {
        if (profileDetailsRedux !== null && profileDetailsRedux !== undefined) {
            setProfileDetails(profileDetailsRedux);
        }
    }, [profileDetailsRedux]);
    React.useEffect(function () {
        // setSelectedPartnerAccount(selectedPartner);
        if (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.accountCode)
            getProfileOverviewDetails();
    }, [selectedPartner]);
    return (React.createElement(React.Fragment, null, overviewLoader || loader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement("section", { id: "profile-details", className: "section-padding element" },
        React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 label-padding" }, "Profile Details"),
        React.createElement(Col, null,
            React.createElement("div", { className: "d-grid profile-grid" },
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "UPC",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.upc))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Partner Code",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.partnerCode))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Partner Created Date",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.partnerCreatedDate))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Partner Type",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.partnerType))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Partner Name",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.partnerName))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Branch Id",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.branchId))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Acquiring RM",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, profileDetails === null || profileDetails === void 0 ? void 0 :
                        profileDetails.acquirerName,
                        "\u00A0(", profileDetails === null || profileDetails === void 0 ? void 0 :
                        profileDetails.acquirerLobName,
                        ")")),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Partner Owner",
                    React.createElement("div", { className: "RobotoM_14_500 txt_blackOne1" }, profileDetails === null || profileDetails === void 0 ? void 0 :
                        profileDetails.frmName,
                        "\u00A0(", profileDetails === null || profileDetails === void 0 ? void 0 :
                        profileDetails.lobName,
                        ")")),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Owner Mapping Date",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.ownerMappingDate))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Agreement Type",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.agreementType))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Partner Tier",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.partnerTier))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Partner Club",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.partnerClub)))))))));
};
export default PartnerProfile;
